module.exports = __webpack_public_path__ + "img/customer-loyalty.ce57218e.png";